<div class="product-world" [ngClass]="{three: noOfpannel=='three',one: noOfpannel=='one'}">
  <!--mobile view header-->
  <div class="" *ngIf="isMobileDevices">
    <div class="mobile-header-bar">
      <div class="left" (click)="gotoPrevious()">
        <img src="assets/icon/m-back.svg" alt="back">
      </div>
      <div class="title">
        <p> {{ pageHeader }}</p>
      </div>
      <div>
      </div>
    </div>
  </div>
  <!---header end-->
  <div class="col-12">
    <swiper [config]="config" [navigation]="{}" [pagination]="{ clickable: true }" [pagination]="{
               type: 'progressbar'
             }" class="mySwiper custom-swiper">
      <ng-template swiperSlide>
        <div class="card bg-dark content2 text-white"
          [ngClass]="{'mob-ht-1': one-pannel,'mob-ht-2': two-pannel,'mob-ht-3': three-pannel}" (click)="closeAllPanels()">
          <div class="content-overlay2"></div>
          <img src="{{sliderData.portalCardImageUrl}}" (error)="sliderData.portalCardImageUrl = 'assets/icon/stbplaceholderlg.svg'" class="card-img" alt="coffe world"
          [ngClass]="{'placeholder-style': sliderData.portalCardImageUrl == 'assets/icon/stbplaceholderlg.svg'}">
          <div class="container">
            <div class="slide-img text-right">
              <img src="assets/icon/expand.svg" class="mr-20" alt="expand-icon" *ngIf="itemType"
                (click)="expandImage(sliderData.portalCardImageUrl)">
              <img src="assets/icon/logo.png" alt="expand-icon" style="width: 62px;height: 62px;" *ngIf="!itemType">
            </div>
          </div>
          <div class="card-img-overlay container"
          [ngClass]="{'move-to-top': isPanelOpened || isPanelOpened1 || isPanelOpened2 }">
            <div class="headings">
              <h5 class="card-title">{{sliderData.cardName}}</h5>
              <p class="card-text" *ngIf="!(isPanelOpened || isPanelOpened1 || isPanelOpened2)">
                {{sliderData.cardDescription | textLimit:wordLimit}}
                <a *ngIf="!isContentToggled && showRead" (click)="toggleContent()">Read More</a>
                <a *ngIf="isContentToggled && showRead" (click)="toggleContent()">Read Less</a>
              </p>
            </div>
          </div>
        </div>
      </ng-template>
    </swiper>
  </div>
</div>